import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, Card } from "antd";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
// import { SchemesService } from "services";
import shortID from "uuid/v4";
import "styles/form.css";
import { List, Map } from "immutable";
import { DOCUMENT_CHECKLIST_CREATOR_FORM, DOCUMENT_CATEGORY_FORM } from "constants/form-fields";
const FormItem = Form.Item;
class AddDocumentChecklistForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        document_categories: this.props.values && this.props.values.size ? this.props.values : new List([]),
        ids: this.props.values ? this.props.values.map((v,k) => k) : new Map({}),
        removed_ids: [],

    }

    componentDidUpdate() {
        // if(this.props.values && this.state.ids && this.props.values.size > this.state.ids.size) {
        //     this.setState({
        //         ids: this.props.values.map((v,k) => k),
        //         removed_ids:[]
        //     });
        // }
    }

    saveFacilityDetails = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            let newValues = new Map(values).filter(_ => !this.state.removed_ids.includes(_)).toList().toArray().map(_ => ({
                ..._,
                business_program: this.props.businessProgramId,
                product_lines: _.product_lines.map(__ => ({
                    product_line: __.id,
                    product_category: __.product_category.id
                }))
            }));
            
            this.props.saveFacilityDetails(newValues);
        });
    }

    toggleFormGrid = (action = "ADD", id) => {
        const { ids } = this.state;
        let removed_ids = this.state.removed_ids;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                ids: ids.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removed_ids.push(id);
            this.setState({
                removed_ids: removed_ids
            });
            break;
        }
        default:
        }
    };

    render() {
        return (
            <Card className={"mb-5"} title={"Document Checklist Creator"}
                extra={
                    [
                        <Button key="save" type="link" onClick={this.saveFacilityDetails}>{this.props.values && this.props.values.first() && this.props.values.first().get("id") ? "Update" : "Save"}</Button>
                    ]
                }
            >
                <div className="mb-10">
                    <div className={"form-row"}>
                        {DOCUMENT_CHECKLIST_CREATOR_FORM.map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        ).toList()}
                    </div>
                    {
                        this.state.ids && this.state.ids.size ?
                            this.state.ids.toList().filter(_ => !this.state.removed_ids.length || !this.state.removed_ids.includes(_)).map(_ => (
                                <div
                                    key={`checklist-${_}`}
                                    className="form-row"
                                >
                                    {DOCUMENT_CATEGORY_FORM.map((field, fieldName) => {
                                        return this.fieldGenerator(
                                            `${_}.${fieldName}`,
                                            field,
                                            this.getErrorOnField(`${_}.${fieldName}`)
                                        )();
                                    }).toList()}
                                    <FormItem className={cx("m-0 form-btn")}>
                                        <Button
                                            shape="circle"
                                            icon={"close"}
                                            onClick={this.toggleFormGrid.bind(
                                                null,
                                                "REMOVE",
                                                _
                                            )}
                                        />
                                    </FormItem>
                                </div>
                            )) : null
                    }
                </div>
                <FormItem className={cx("form-btn m-0")}>
                    <Button
                        type="dashed"
                        icon={"plus"}
                        // disabled={this.props.formDisabled}
                        onClick={this.toggleFormGrid.bind(null, "ADD")}>
                        Add New Category
                    </Button>
                </FormItem>
            </Card>
        );
    }
}

AddDocumentChecklistForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    saveFacilityDetails: PropTypes.func,
    businessProgramId: PropTypes.number
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
        values
            .map(_ => new Map(_)
                .map((value) => {
                    return Form.createFormField({
                        value
                    });
                }).toJS()
            ).toJS();
    }
})(AddDocumentChecklistForm);